import { UseCase } from '@/shared/application/UseCase';
import { Quote } from '@/application/shared/domain/Quote';
import { PlanListRepository } from '@/planList/domain/PlanListRepository';
import { PlanResponse } from '@/planList/domain/PlanResponse';
import { SfApiResponse } from '@hfc/ui-core';

export class GetVisionPlanUseCase implements UseCase<Quote, SfApiResponse<Array<PlanResponse>>> {

  private repository: PlanListRepository;

  public constructor (repository: PlanListRepository) {
    this.repository = repository;
  }

  public async run (quoteData: Quote): Promise<SfApiResponse<Array<PlanResponse>>> {
    return await this.repository.getPlans(quoteData);
  }

}
